'use strict';

angular.module('cdPay.routes.notFound', []).component('notFound', {
  templateUrl: 'routes/not-found/not-found.html',
  bindings: {
    errorCode: '<',
  },
});
